/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input, ViewContainerRef, inject } from '@angular/core';
import { Resource } from '@ngxp/rest';
import { OzgcloudDialogService } from '@odc/component';
import { SearchZustaendigeStelleDialogComponent } from '../search-zustaendige-stelle-dialog/search-zustaendige-stelle-dialog.component';

@Component({
  selector: 'alfa-edit-zustaendige-stelle-button',
  templateUrl: './edit-zustaendige-stelle-button.component.html',
  standalone: false,
})
export class EditZustaendigeStelleButtonComponent<T extends Resource> {
  private readonly dialogService = inject(OzgcloudDialogService);
  readonly viewContainerRef = inject(ViewContainerRef);

  @Input() public dataTestId: string;
  @Input() title: string;

  public openSearchDialog(): void {
    this.dialogService.openFullScreenDialog<SearchZustaendigeStelleDialogComponent<T>>(
      SearchZustaendigeStelleDialogComponent,
      this.viewContainerRef,
      this.title,
    );
  }
}
